import React, { useState } from 'react';
import Input from 'components/element/Input';
import Button from 'components/element/Button';

const TwutForm = ({ initialContent = '', onSubmit, onCancel, isProcessing, placeholder = "What's on your mind?" }) => {
  const [content, setContent] = useState(initialContent);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (content.trim()) {
      onSubmit({ content: content.trim() });
      setContent('');
      setErrorMessage('');
    } else {
      setErrorMessage('Please enter some text.');
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleChange = (e) => {
    setContent(e.target.value);
    if (errorMessage) {
      setErrorMessage('');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Input value={content} onChange={handleChange} placeholder={placeholder} className="w-full mb-2" rows={3} />
      {errorMessage && (
        <div className="mb-4 text-sm text-red-more">{errorMessage}</div>
      )}
      <div className="flex justify-end space-x-2">
        <Button type="submit" isLoading={isProcessing} disabled={!content.trim()} className="w-22 py-2.5 text-white bg-blue-mid hover:bg-blue-more">
          {initialContent ? 'Update' : onCancel ? 'Reply' : 'Post'}
        </Button>
        {onCancel && (
          <Button type="button" onClick={handleCancel} className="w-22 py-2.5 text-white bg-gray-mid hover:bg-gray-more">
            Cancel
          </Button>
        )}
      </div>
    </form>
  );
}

export default TwutForm;
